import React from "react";
import OwlCarousel from "react-owl-carousel";
import { useLocation } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import { pageRoutes } from "../../routes/pageRoutes";
import "owl.carousel/dist/assets/owl.theme.default.css";
const Testimonials = () => {
  const { pathname } = useLocation();
  const options = {
    loop: true,
    margin: 10,
    nav: true,
    center: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };
  return (
    <>
      {/* Start Testimonial Slider */}
      <div
        class={`testimonial-section untree_co-section ct_service_bg ${
          pathname === pageRoutes?.services ? "ct_testimonial_bg_remove" : ""
        }`}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-7 mx-auto text-center">
              <h2 class="section-title mb-5">
                <strong className="text-white">Testimonials</strong>
              </h2>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="testimonial-slider-wrap text-center">
                <div class="testimonial-slider">
                  <OwlCarousel className="owl-theme" {...options}>
                    <div class="item">
                      <div class="row justify-content-center">
                        <div class="col-lg-8 mx-auto">
                          <div class="testimonial-block text-center">
                            <blockquote class="mb-5">
                              <p>
                                &ldquo;“We're a small and growing educational
                                services company, on the leading-edge of
                                educational technology. We look forward to
                                building your next project, or training your
                                staff. Let's create something amazing,
                                together!​" &rdquo;
                              </p>
                            </blockquote>

                            <div class="author-info">
                              <div class="author-pic d-flex justify-content-center">
                                <img
                                  src="images/person-1.png"
                                  alt="Maria Jones"
                                  class="img-fluid"
                                />
                              </div>
                              <h3 class="font-weight-bold">Christopher Miko</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row justify-content-center">
                        <div class="col-lg-8 mx-auto">
                          <div class="testimonial-block text-center">
                            <blockquote class="mb-5">
                              <p>
                                &ldquo;“We're a small and growing educational
                                services company, on the leading-edge of
                                educational technology. We look forward to
                                building your next project, or training your
                                staff. Let's create something amazing,
                                together!​" &rdquo;
                              </p>
                            </blockquote>

                            <div class="author-info">
                              <div class="author-pic d-flex justify-content-center">
                                <img
                                  src="images/person-1.png"
                                  alt="Maria Jones"
                                  class="img-fluid"
                                />
                              </div>
                              <h3 class="font-weight-bold">Christopher Miko</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Testimonial Slider */}
    </>
  );
};

export default Testimonials;
